import { Injectable } from '@angular/core';
import { Adapter } from '../adapter.service';
import { Karyawan } from '../../../models/pegawai/karyawan.model';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class KaryawanAdapter implements Adapter<Karyawan> {
  public adapt(item: any): Karyawan {
    return {
      id: item.idKaryawan ? item.idKaryawan : item.id,
      nama: item.nama,
      namaPanggilan: item.namaPanggilan,
      kode: item.kode,
      email: item.email,
      jenisKelamin: item.jenisKelamin,
      jenisNik: item.jenisNik,
      nik: item.nik,
      noTelp: item.noTelp,
      foto: item.foto,
      idProfesi: item.idProfesi,
      npwp: item.npwp,
      nipNrp: item.nipNrp,
      noSip: item.noSip,
      noKartuPegawai: item.noKartuPegawai,
      bpjs: item.bpjs,
      bpjsKetenagakerjaan: item.bpjsKetenagakerjaan,
      statusKepegawaian: item.statusKepegawaian,
      tempatLahir: item.tempatLahir,
      tanggalLahir: moment(item.tanggalLahir).isValid() ? new Date(item.tanggalLahir) : null,
      tmtCpns: moment(item.tmtCpns).isValid() ? new Date(item.tmtCpns) : null,
      bank: item.bank,
      noRekening: item.noRekening,
      atasNama: item.atasNama,
      asuransiLain: item.asuransiLain,
      tanggalExpired: moment(item.tanggalExpired).isValid() ? new Date(item.tanggalExpired) : null,
      jamsostek: item.jamsostek,
      profesi: {
        id: item._embedded?.profesi.id || item.idMsprofesi,
        nama: item._embedded?.profesi.nama || item.profesi,
        jasa: item._embedded?.profesi.jasa,
      },
      kategoriKaryawan: {
        id: item._embedded?.kategoriKaryawan.id || item.idKategoriKaryawan,
        nama: item._embedded?.kategoriKaryawan.nama || item.kategoriKaryawan,
      },
      golonganDarah: {
        id: item._embedded?.golonganDarah.id,
        nama: item._embedded?.golonganDarah.nama,
      },
      agama: {
        id: item._embedded?.agama.id || item.idAgama,
        nama: item._embedded?.agama.nama || item.agama,
      },
      alamat: item.alamat,
      spesialis: {
        id: item._embedded?.spesialis?.id || null,
        nama: item._embedded?.spesialis.nama,
      },
      statusPerkawinan: {
        id: parseInt(item._embedded?.statusPerkawinan.id || item.idStatusPerkawinan, 10),
        nama: item._embedded?.statusPerkawinan.nama || item.statusPerkawinan,
      },
      direktorat: {
        id: item._embedded?.direktorat.id || item.idDirektorat,
        nama: item._embedded?.direktorat.nama || item.direktorat,
      },
      unitKerja: item.unitKerja,
      satuanOrganisasi: {
        id: item._embedded?.satuanOrganisasi.id || item.idSatuanOrganisasi,
        nama: item._embedded?.satuanOrganisasi.nama || item.satuanOrganisasi,
      },
      golonganJabatan: {
        id: item._embedded?.golonganJabatan.id || item.idGolonganJabatan,
        nama: item._embedded?.golonganJabatan.nama || item.golonganJabatan,
      },
      idGudang: item.idGudang,
      idGudangDistribusi: item.idGudangDistribusi,
      idRuang: item.idRuang,
      idRak: item.idRak,
      jabatan: {
        id: item._embedded?.jabatan.id || item.idJabatan,
        nama: item._embedded?.jabatan.nama || item.jabatan,
        statusJabatan: item._embedded?.statusJabatan.nama,
        pensiun: null,
      },
      str: item.noStr,
      statusRumah: item.statusRumah,
      idInstalasi: item.idInstallasi,
      referenceInstalasi: {
        id: item._embedded?.referenceInstallasi.id || item.idReferenceInstallasi,
        nama: item._embedded?.referenceInstallasi.nama || item.referenceInstalasi,
      },
      tmt: item._embedded?.tmt,
      idReferenceDokterBpjs: item.idReferenceDokterBpjs,
      idSatusehat: item.idSatusehat,
      noStr: item.str,
      klinik: item.instalasi,
      contractExpiredOn: item.contractExpiredOn,
      contractEndDate: item.contractEndDate,
      sipExpiredOn: item.sipExpiredOn,
      sipStartDate: item.sipStartDate,
      sipEndDate: item.sipEndDate,
      strExpiredOn: item.strExpiredOn,
      strStartDate: item.strStartDate,
      strEndDate: item.strEndDate,
      fotoTtd: item.fotoTtd,
      kodeDokterPcare: item.kodeDokterPcare,
      url: item.url,
      statusPendaftaranKunjunganPasien: item.statusPendaftaranKunjunganPasien,
      alasanNonaktif: item.alasanNonaktif,
      lastSelectedPolyclinicId: item.lastSelectedPolyclinicId,
      indikatorFeeDokter: item.indikatorFeeDokter,
      deactivateBy: item.deactivateBy,
    };
  }

  /** Used to adapt items from v2 API routes. */
  public adaptV2(item: any): Karyawan {
    // ? Add more attributes if needed here.
    return {
      id: item.idKaryawan,
      nama: item.nama,
      namaPanggilan: item.namaPanggilan,
      kode: item.kode,
      nik: item.nik,
      nipNrp: item.nipNrp,
      noSip: item.noSip,
      profesi: {
        id: item.idMsprofesi,
        nama: item.profesi,
        jasa: item.jasa,
      },
      kategoriKaryawan: {
        id: item.idKategoriKaryawan,
        nama: item.kategoriKaryawan,
      },
      agama: {
        id: item.idAgama,
        nama: item.agama,
      },
      golonganJabatan: {
        id: item.idGolonganJabatan,
        nama: item.golonganJabatan,
      },
      jabatan: {
        id: item.idJabatan,
        nama: item.jabatan,
        statusJabatan: null,
        pensiun: null,
      },
      referenceInstalasi: {
        id: item.idReferenceInstallasi,
        nama: item.referenceInstalasi,
      },
      satuanOrganisasi: {
        id: item.idSatuanOrganisasi,
        nama: item.satuanOrganisasi,
      },
      statusPerkawinan: {
        id: parseInt(item.idStatusPerkawinan, 10),
        nama: item.statusPerkawinan,
      },
      idGudang: item.idGudang,
      idGudangDistribusi: item.idGudangDistribusi,
      idRak: item.idRak,
      alamat: item.alamat,
      email: item.email,
      idJabatan: item.idJabatan,
      foto: item.foto,
      spesialis: {
        id: item.idSpesialis,
        nama: undefined,
      },
      idReferenceDokterBpjs: item.idReferenceDokterBpjs,
      idReferenceNavigation: item.idReferenceNavigation,
      idLogin: item.idLogin,
      klinik: item.instalasi,
      contractExpiredOn: item.contractExpiredOn,
      contractEndDate: item.contractEndDate,
      fotoTtd: item.fotoTtd,
      kodeDokterPcare: item.kodeDokterPcare,
      indikatorFeeDokter: item.indikatorFeeDokter,
      url: item.url,
      unitKerja: item.unitKerja,
      statusPendaftaranKunjunganPasien: item.statusPendaftaranKunjunganPasien,
      deactivateBy: item.deactivateBy,
    };
  }

  public adaptGo(item: any): Karyawan {
    return {
      id: item.idKaryawan,
      uuid: item.uuid,
      nama: item.nama,
      namaPanggilan: item.namaPanggilan,
      kode: item.kode,
      email: item.email,
      jenisKelamin: item.jenisKelamin,
      jenisNik: item.jenisNik,
      nik: item.nik,
      noTelp: item.noTelp,
      foto: item.foto,
      idProfesi: item.idProfesi,
      npwp: item.npwp,
      nipNrp: item.nipNrp,
      noSip: item.noSip,
      noKartuPegawai: item.noKartuPegawai,
      bpjs: item.bpjs,
      bpjsKetenagakerjaan: item.bpjsKetenagakerjaan,
      statusKepegawaian: item.statusKepegawaian,
      tempatLahir: item.tempatLahir,
      tanggalLahir: moment(item.tanggalLahir).isValid() ? new Date(item.tanggalLahir) : null,
      tmtCpns: moment(item.tmtCpns).isValid() ? new Date(item.tmtCpns) : null,
      bank: item.bank,
      noRekening: item.noRekening,
      atasNama: item.atasNama,
      asuransiLain: item.asuransiLain,
      tanggalExpired: moment(item.tanggalExpired).isValid() ? new Date(item.tanggalExpired) : null,
      jamsostek: item.jamsostek,
      profesi: {
        id: item.profesi?.id,
        nama: item.profesi?.nama,
        jasa: item.profesi?.jasa,
      },
      kategoriKaryawan: {
        id: item.kategoriKaryawan?.idKategoriKaryawan,
        nama: item.kategoriKaryawan?.nama,
      },
      golonganDarah: {
        id: item.golonganDarah?.id,
        nama: item.golonganDarah?.nama,
      },
      agama: {
        id: item.agama?.id,
        nama: item.agama?.nama,
      },
      alamat: item.alamat,
      spesialis: {
        id: item.spesialis?.id,
        nama: item.spesialis?.nama,
      },
      statusPerkawinan: {
        id: item.statusPerkawinan?.id,
        nama: item.statusPerkawinan?.nama,
      },
      direktorat: {
        id: item.direktorat?.id,
        nama: item.direktorat?.nama,
      },
      unitKerja: item.unitKerja,
      satuanOrganisasi: {
        id: item.satuanOrganisasi?.id,
        nama: item.satuanOrganisasi?.nama,
      },
      golonganJabatan: {
        id: item.golonganJabatan?.id,
        nama: item.golonganJabatan?.nama,
      },
      idGudang: item.idGudang,
      idGudangDistribusi: item.idGudangDistribusi,
      idRuang: item.idRuang,
      idRak: item.idRak,
      idRakDistribusi: item.idRakDistribusi,
      jabatan: {
        id: item.jabatan?.id,
        nama: item.jabatan?.nama,
        statusJabatan: item.statusJabatan?.nama,
        pensiun: null,
      },
      str: item.noStr,
      statusRumah: item.statusRumah,
      idInstalasi: item.idInstalasi,
      referenceInstalasi: {
        id: item.referenceInstalasi?.id,
        nama: item.referenceInstalasi?.nama,
      },
      tmt: item.tmt,
      idReferenceDokterBpjs: item.idReferenceDokterBpjs,
      noStr: item.str,
      klinik: item.instalasi,
      idSatusehat: item.idSatusehat,
      contractExpiredOn: item.riwayatKontrak?.contractExpiredOn,
      contractEndDate: item.riwayatKontrak?.contractEndDate,
      sipExpiredOn: item.riwayatKredensial?.sipExpiredOn,
      sipStartDate: item.riwayatKredensial?.sipStartDate,
      sipEndDate: item.riwayatKredensial?.sipEndDate,
      strExpiredOn: item.riwayatKredensial?.strExpiredOn,
      strStartDate: item.riwayatKredensial?.strStartDate,
      strEndDate: item.riwayatKredensial?.strEndDate,
      fotoTtd: item.fotoTtd,
      kodeDokterPcare: item.kodeDokterPcare,
      indikatorFeeDokter: item.indikatorFeeDokter,
      url: item.url,
      statusPendaftaranKunjunganPasien: item.statusPendaftaranKunjunganPasien,
      alasanNonaktif: item.alasanNonaktif,
      usernamePcare: item.usernamePcare,
      passwordPcare: item.passwordPcare,
      lastSelectedPolyclinicId: item.lastSelectedPolyclinicId,
    };
  }
}
